export default __webpack_public_path__ + "media/transfer_window/transfer_blocked-74371bf1.svg";